<template>
  <a-modal
    :visible="true"
    width="510px"
    :body-style="bodyStyle"
    :mask-closable="false"
    centered
    :footer="null"
    :keyboard="false"
    @cancel="handleCloseModalHeader"
  >
    <div class="container__inactive">
      <img class="image__delete" src="@/app/users/assets/profiles/delete.png" alt="delete" />
      <p class="text__alert">¿Estás seguro de eliminar permanentemente la empresa</p>
      <p class="text__alert">“{{ record.name }}”?</p>
    </div>
    <div class="container__info">
      <p class="text">Sucederán las siguientes acciones:</p>
      <ul>
        <li>Se desactivarán las campañas, bases, estrategias y colas asociadas a esta empresa.</li>
        <li>Los canales se desconectarán de las colas asociadas a esta empresa.</li>
        <li>Los tickets se finalizarán automáticamente.</li>
      </ul>
      <p>
        Si estás seguro de eliminar esta empresa, haz click en “Enviar código de verificación” y
        revisa la bandeja de entrada de tu correo electrónico.
      </p>
    </div>
    <a-form class="form" ref="formRef" layout="vertical" :model="formState" :rules="rules">
      <a-row :gutter="24">
        <a-col span="24">
          <a-form-item class="form__item" label="Correo electrónico" name="email">
            <a-input v-model:value="formState.email" placeholder="Escribe aquì..." />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="button__disabled">
      <a-button
        style="width: 100%"
        class="footer__delete"
        type="primary"
        @click="handleCloseModal"
        :loading="loading"
      >
        Enviar código de verificación
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import { UserStatus } from "@/app/shared/utils/enums";

export default defineComponent({
  name: "InactiveUserModal",
  props: {
    record: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    emailToDelete: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const formRef = ref();
    const store = useStore();
    const loggedUser = computed(() => store.getters["getDataUser"]?.email);

    const bodyStyle = {
      height: "620px",
      padding: "30px 37px 37px",
      loading: false,
    };
    const formState = reactive({
      email: props.emailToDelete || loggedUser.value,
    });
    const rules = {
      email: [
        {
          type: "email",
          required: true,
          message: "Correo inválido",
        },
      ],
    };
    return {
      bodyStyle,
      rules,
      formState,
      formRef,
      loggedUser,
    };
  },
  data() {
    return {
      UserStatus,
      loading: false,
    };
  },
  created() {
    // this.$store.dispatch("fetchDataUser");
  },
  methods: {
    handleCloseModal() {
      this.$emit("onCancel");
      this.updateStatus();
    },
    handleCloseModalHeader() {
      this.$emit("onCloseModal");
    },
    updateStatus() {
      this.formRef.validateFields().then(async () => {
        try {
          this.loading = true;
          const data = {
            email: this.formState.email,
            entity: this.record.id,
          };
          await this.$store.dispatch("sendEntityToken", data);
          this.loading = false;
          this.$emit("onOpenModal", this.formState.email);
        } catch (error) {
          this.loading = false;
          this.$message.error("Error al eliminar la empresa");
        }
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.image__delete
  margin-bottom: 10px

.text__alert
  font-size: 16px
  font-weight: 600
  margin-bottom: 0
  color: $gray-13

.text
  margin-bottom: 20px
  margin-top: 20px

.button__disabled
  margin-top: 10px

.strong
  font-weight: 600

.footer__delete
  margin-bottom: 20px

.container__inactive
  margin-top: 30px
  text-align: center

.container__info
  margin-bottom: 18px
  color: $gray-8

.form__item
  color: $gray-8
</style>
